module.exports = __webpack_public_path__ + "img/IMG_0255.4c595474.jpg";